import React from "react";
import Layout from "Layout";
import Form from "./form";
import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import useError from "Hooks/useError";
import { animateScroll as scroll } from 'react-scroll';
import googleAnalytics from "fuction/googleAnalytics";

export default function Edit(props) {
  const { params } = props.match;
  const taskId = parseInt(params.id, 10);
  const auth = useAuth();
  const { request } = useApi();
  const stateError = useError();
  const [analysisData, setData] = React.useState([]);
  const [noises, setNoises] = React.useState([]);
  const [labels, setLabels] = React.useState([]);
  const [dailyFlag, setDailyFlag] = React.useState(false);

  const [maxLabel, setMaxLabels] = React.useState([]);

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  // 投稿分類有効確認
  const isAnalysis = () => {
    if (JSON.parse(localStorage.getItem("user"))?.options?.analysis == true || JSON.parse(localStorage.getItem("user"))?.options?.analysis== "true") {
        return true;
    }
    else {
      return false;
    }
  };

  const fetchData = () => {
    if (!auth.state.activeGroup) {
      return;
    }

    // タスク情報取得
    request({
      method: "GET",
      url: `config/:account_id/analysis/information/${auth.state.activeGroup}/${taskId}`,
    }).then((data) => {
      setData(data.data);
      if (analysisData.daily_iterate) {
        setDailyFlag(true);
      }
    });
    
    // ノイズ辞書一覧取得
    request({
      method: "GET",
      url: `config/:account_id/analysis/noises`,
    }).then((data) => {
      setNoises(data.data);
    });

    // 分類辞書一覧取得
    request({
      method: "GET",
      url: `config/:account_id/analysis/labels`,
    }).then((data) => {
      setLabels(data.data);
    });

    // 分類辞書登録上限数取得
    request({
      method: "POST",
      url: `config/:account_id/account`,
      data: {
        "attrs": [
          "max_labels",
        ]
      },
    }).then((account) => {
      // mapで描画するため、配列として設定
      let labelArry = [];
      let maxnum = account.data.max_labels;
      for (let i = 0;  i < maxnum;  i++) {
        labelArry.push(i);
      }
      setMaxLabels(labelArry);
    });
  };

  React.useEffect(() => {
    if(!isAnalysis()) return;

    // タイトル変更
    document.title = "Buzz Finder - 投稿分類タスク編集";
    
    fetchData();
    scrollToTop()
  }, [auth.state.activeGroup]);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  const handleSubmit = ({
      name,
      desc,
      dailyIterate,
      rangeFrom,
      rangeUntil,
      sendNotify,
      dictNoises,
      dictLabels
    }) => {
    request({
      method: "PUT",
      url: `config/:account_id/analysis/information/${auth.state.activeGroup}/${taskId}`,
      data: {
        name: name,
        desc: desc,
        daily_iterate: dailyIterate,
        send_notify: sendNotify,
        range_from: rangeFrom,
        range_until: rangeUntil,
        dict_noises: dictNoises,
        dict_labels: dictLabels,
      },
    })
    .then((data) => {
      stateError.initialize();
      props.history.push("/analysistask?success=edit");
    })
    .catch((error) => {
      stateError.initialize();
      let errorMsg = messages.validation.common;
      if (error.response.data.errors?.name?.[0].error) {
        let err = error.response.data.errors.name[0].error;
        if (err === "taken") {
          let errMsgSub = error.response.data.errors.name[0].value;
          errorMsg = messages.errorMsg.duplicateTaskName + "（" + errMsgSub + "）";
        }
      } else if (error.response.data.errors?.dict_noises?.[0].error) {
        let err = error.response.data.errors.dict_noises[0].error;
        let errMsgSub = "";
        switch(true) {
          case /text/.test(err) : errMsgSub += "ノイズ辞書(ツイート本文) "; break;
          case /user_name/.test(err) : errMsgSub += "ノイズ辞書(投稿者名) "; break;
          case /screen_name/.test(err) : errMsgSub += "ノイズ辞書(投稿者ID) "; break;
          case /user_desc/.test(err) : errMsgSub += "ノイズ辞書(投稿者説明文) "; break;
        }
        errorMsg = messages.validation.common + "（" + errMsgSub + "）";
      } else if (error.response.data.errors?.dict_labels?.[0].error) {
        let errMsgSub = error.response.data.errors.dict_noises[0].error;
        errorMsg = messages.validation.common + "（" + errMsgSub + "）";
      } else if (error.response.data.errors?.range_from?.[0].error) {
        errorMsg = messages.validation.common + "（期間指定　始点日時）";
      } else if (error.response.data.errors?.range_until?.[0].error) {
        errorMsg = messages.validation.common + "（期間指定　終点日時）";
      }
      stateError.dispatch({
        type: "set",
        payload: {
          isError: true,
          errorMsg: errorMsg,
        },
      });
    });
  };

  return (
    <Layout
      content={
        <Form
          data={analysisData}
          noises={noises}
          labels={labels}
          labelMax={maxLabel}
          isMode="edit"
          dailyFlag={dailyFlag}
          adminFlag={auth.state.user.admin}
          submit={handleSubmit}
        />
      }
    />
  );
}
